import React from 'react';
export const ExtendedTestimonialsSection = ({
  isInitial = false
}: {
  isInitial?: boolean;
}) => {
  const initialTestimonials = [{
    initials: 'MP',
    name: 'Marta R.',
    city: 'Ciudad de México',
    desc: 'Hija y cuidadora familiar · Ciudad de México',
    quote: 'Con Mente Despierta dejamos de pasar la tarde buscando qué hacer. Elegimos una ficha, la leemos juntas y seguimos a nuestro ritmo. Las instrucciones son muy fáciles de entender.'
  }, {
    initials: 'RC',
    name: 'Ricardo G.',
    city: 'Madrid, España',
    desc: 'Cuidador profesional a domicilio · Madrid, España',
    quote: 'El Módulo Maestro me da opciones físicas y cognitivas organizadas por niveles. Me ayuda a preparar mejor las rutinas y a explicar a cada familia cómo acompañarlas en casa.'
  }, {
    initials: 'SL',
    name: 'Silvina M.',
    city: 'Miami, USA',
    desc: 'Hija a cargo · Miami, USA',
    quote: 'Cocina Vital me dio ideas sencillas para planificar las comidas de la semana. Me ahorra tiempo y me sirve como punto de partida para conversar las necesidades de mi papá con su profesional.'
  }];
  const extendedTestimonials = [...initialTestimonials, {
    initials: 'GP',
    name: 'Gabriela P.',
    city: 'Bogotá, Colombia',
    desc: 'Nuera y cuidadora · Bogotá, Colombia',
    quote: 'Cuidado Experto me ayudó a ordenar mis dudas y a identificar qué información conviene tener preparada para una consulta. Ahora siento que la rutina tiene más claridad.'
  }, {
    initials: 'LF',
    name: 'Laura F.',
    city: 'Santiago, Chile',
    desc: 'Hija y cuidadora · Santiago, Chile',
    quote: 'La Bitácora de Control 360 reunió las notas que antes estaban en distintos papeles. Llevar la medicación, el sueño y los controles ordenados a las consultas nos resulta mucho más práctico.'
  }, {
    initials: 'JR',
    name: 'Javier R.',
    city: 'Ciudad de México',
    desc: 'Nieto y cuidador familiar · Ciudad de México',
    quote: 'Movilidad Sin Miedo está explicado con dibujos y eso nos facilitó empezar juntos con rutinas en silla. Es un momento sencillo que ahora compartimos con más confianza.'
  }, {
    initials: 'AM',
    name: 'Andrea M.',
    city: 'Madrid, España',
    desc: 'Hija y organizadora familiar · Madrid, España',
    quote: 'Las Cartas de Reminiscencia abrieron conversaciones que no teníamos antes. Mi hijo participa, mi papá comparte historias y las reuniones familiares se sienten más conectadas.'
  }, {
    initials: 'CM',
    name: 'Carolina M.',
    city: 'Miami, USA',
    desc: 'Cuidadora principal · Miami, USA',
    quote: 'La Guía del Cuidador me dio una manera concreta de hablar con mis hermanos sobre tareas y descansos. Poder distribuir responsabilidades cambió cómo organizamos la semana.'
  }];
  const data = isInitial ? initialTestimonials : extendedTestimonials;
  return <section className={`py-10 md:py-16 px-4 md:px-6 ${isInitial ? 'bg-familia-bg' : 'bg-familia-card'}`} data-id="element-56">
      <div className="max-w-7xl mx-auto w-[92%] md:w-full" data-id="element-57">
        {!isInitial && <h2 className="text-[22px] sm:text-3xl md:text-4xl font-display font-bold text-center mb-8 md:mb-12" data-id="element-58">
            Lo que dicen las familias y cuidadores que ya{' '}
            <br className="hidden sm:block" data-id="element-59" /> usan Vitalidad 360™:
          </h2>}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-id="element-60">
          {data.map((t, i) => <div key={i} className="bg-familia-section border border-familia-cyan/25 p-5 md:p-8 rounded-2xl card-hover flex flex-col" data-id="element-61">
              <div className="flex items-center gap-4 mb-4 md:mb-6" data-id="element-62">
                <div className="w-12 h-12 rounded-full bg-familia-cyan text-familia-bg flex items-center justify-center font-bold text-lg shrink-0" data-id="element-63">
                  {t.initials}
                </div>
                <div data-id="element-64">
                  <div className="text-familia-gold text-sm mb-1" data-id="element-65">
                    ⭐⭐⭐⭐⭐
                  </div>
                  <div className="font-bold text-sm" data-id="element-66">{t.name}</div>
                  <div className="text-familia-gray text-[10px] uppercase tracking-wider" data-id="element-67">
                    {t.city}
                  </div>
                </div>
              </div>
              <p className="text-white/90 italic mb-4 md:mb-6 flex-grow leading-relaxed text-[15px]" data-id="element-68">
                "{t.quote}"
              </p>
              <div className="text-xs font-semibold text-familia-cyan/90 pt-4 border-t border-white/10" data-id="element-69">
                {t.desc}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};